import { FormattedMessage, useIntl } from "react-intl";

import { ReactComponent as MailIcon } from "assets/images/iconsV2/mail-01.svg";
import { ReactComponent as PlusIcon } from "assets/images/iconsV2/plus.svg";
import Button from "components/v2/Button/Button";
import EmptyState from "components/v2/EmptyState/EmptyState";
import DataTable, { DataTableV2Props } from "components/v2/Table/DataTable";
import Tablefooter from "components/v2/Tablefooter/Tablefooter";
import "./EmailNotifications.scss";

type EmailNotificationListProps = {
  fetching: boolean;
  tableInstance: DataTableV2Props["tableInstance"];
  totalPages: number;
  totalData: number;
  currentPage: number;
  itemsPerPage: number;
  onItemsPerPageChange: (size: number) => void;
  onPageClick: (page: number) => void;
};

function EmailNotificationList({
  fetching,
  tableInstance,
  totalPages,
  totalData,
  currentPage,
  itemsPerPage,
  onItemsPerPageChange,
  onPageClick,
}: EmailNotificationListProps) {
  const intl = useIntl();

  if (fetching) {
    return <DataTable tableInstance={tableInstance} tableLayout="fixed" isLoading />;
  }

  if (totalData === 0) {
    return (
      <div className="email-notifications-empty py-11xl">
        <EmptyState
          title={intl.formatMessage({
            id: "settings.emailNotifications.emptyTitle",
            defaultMessage: "No notifications set up yet",
          })}
          description={intl.formatMessage({
            id: "settings.emailNotifications.emptyDescription",
            defaultMessage: "Create one now and automate your communication",
          })}
          customIcon={
            <div className="d-flex justify-content-center align-items-center w-48-px h-48-px radius-sm shadow-xs border-1 border-solid border-secondary">
              <MailIcon />
            </div>
          }
          customActions={
            <Button
              label={intl.formatMessage({
                id: "settings.emailNotifications.new",
                defaultMessage: "New notification",
              })}
              iconLeft={<PlusIcon />}
              size="lg"
            />
          }
        />
      </div>
    );
  }

  return (
    <div className="email-notifications-table-container shadow-xs radius-md bg-primary">
      <div className="d-flex justify-content-between gap-lg align-items-center py-xl px-3xl bg-primary">
        <div className="text-md font-medium text-primary">
          <FormattedMessage id="settings.emailNotifications.all" defaultMessage="All notifications" />
        </div>
        <Button
          label={intl.formatMessage({
            id: "settings.emailNotifications.add",
            defaultMessage: "Add notification",
          })}
          iconLeft={<PlusIcon />}
          size="sm"
        />
      </div>
      <DataTable tableInstance={tableInstance} tableLayout="fixed" />
      <Tablefooter
        totalPages={totalPages}
        totalData={totalData}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={onItemsPerPageChange}
        pageClicked={onPageClick}
      />
    </div>
  );
}

export default EmailNotificationList;
